import angular from 'angular';
import { MeurhSolicitacoesalteracoesenderecosService } from './solicitacoesalteracoesenderecos.service';
import { ListagemService } from '../../../shared/services/listagem.service';

export const MeurhSolicitacoesalteracoesenderecosListRouting = [
    '$stateProvider',
    function($stateProvider: angular.ui.IStateProvider) {
        const resolve = {
            'entity': [
                'MeurhSolicitacoesalteracoesenderecosService',
                'ListagemService',
                '$rootScope',
                '$stateParams',
                '$state',
                '$q',
                function(
                    entityService: MeurhSolicitacoesalteracoesenderecosService,
                    listagemService: ListagemService,
                    $rootScope: angular.IRootScopeService & {
                        session: any,
                        liberadoTela: (arg: string) => boolean
                    },
                    $stateParams: angular.ui.IStateParamsService,
                    $state: angular.ui.IStateService,
                    $q: angular.IQService
                ) {
                    if (!$stateParams['solicitacao']) {
                        return $q<void>(() => $state.go('meurh_solicitacoesalteracoesenderecos'));
                    }

                    return entityService.get($stateParams['solicitacao'])
                        .then((data) => {
                            const visibilidadeLiberada = $rootScope.liberadoTela('LIBERAR_REFATORACAO_VISIBILIDADE');
                            const empresaNoGrupo = listagemService.getEmpresa(data.empresaobj.empresa);
                            const mesmoEstabelecimento = data.estabelecimentoobj.estabelecimento === $rootScope.session.entities.estabelecimento.estabelecimento;

                            const deveRedirecionar = (
                                (visibilidadeLiberada && !empresaNoGrupo) ||
                                (!visibilidadeLiberada && !mesmoEstabelecimento)
                            );

                            if (deveRedirecionar) {
                                return $q(() => $state.go('meurh_solicitacoesalteracoesenderecos'));
                            }

                            return data;
                        })
                        .catch((error) => {
                            if (error.status === 404) {
                                return $q(() => {
                                    if ($state.href('meurh_solicitacoesalteracoesenderecos_not_found', $stateParams)) {
                                        $state.go('meurh_solicitacoesalteracoesenderecos_not_found', $stateParams);
                                    } else {
                                        $state.go('not_found', $stateParams);
                                    }
                                });
                            }

                            return $q.reject(error);
                        });
                }
            ]
        };

        $stateProvider
            .state('meurh_solicitacoesalteracoesenderecos', {
                url: '/solicitacoes/alteracoesenderecos?q?tipo',
                template: require('html-loader!./index/solicitacoesalteracoesenderecos.index.html'),
                controller: 'Meurh\SolicitacoesalteracoesenderecosIndexController',
                controllerAs: 'mrh_slctcsltrcsndrc_lst_cntrllr',
                reloadOnSearch: false
            })

            .state('meurh_solicitacoesalteracoesenderecos_new', {
                parent: 'meurh_solicitacoesalteracoesenderecos',
                url: '/new',
                template: require('html-loader!./new/solicitacoesalteracoesenderecos.new.html'),
                controller: 'MeurhSolicitacoesalteracoesenderecosNewController',
                controllerAs: 'mrh_slctcsltrcsndrc_frm_nw_cntrllr'
            })
            .state('meurh_solicitacoesalteracoesenderecos_show', {
                parent: 'meurh_solicitacoesalteracoesenderecos',
                url: '/show/:solicitacao?path',
                resolve,
                template: require('html-loader!./show/solicitacoesalteracoesenderecos.show.html'),
                controller: 'MeurhSolicitacoesalteracoesenderecosShowController',
                controllerAs: 'mrh_slctcsltrcsndrc_frm_shw_cntrllr'
            })
            .state('meurh_solicitacoesalteracoesenderecos_edit', {
                parent: 'meurh_solicitacoesalteracoesenderecos',
                url: '/edit/:solicitacao',
                resolve,
                template: require('html-loader!./edit/solicitacoesalteracoesenderecos.edit.html'),
                controller: 'MeurhSolicitacoesalteracoesenderecosEditController',
                controllerAs: 'mrh_slctcsltrcsndrc_frm_edit_cntrllr'
            });
    }];
